import { Badge, Button, DialogContent } from "@mui/material";
import FilterBar from "common/components/FilterBar/FilterBar";
import GenericDialog from "common/components/GenericDialog/GenericDialog";
import { ApiService } from "common/services/ApiService";
import { useAuth } from "context/AuthContext";
import moment from "moment";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PENDING_NOTIFICATION_MAP, VISIBILITY_MAP } from "utils/constants";

const CourseActivitiesList = ({ columnVisibilityModel, courseId }) => {
    const navigate = useNavigate();
    const { auth } = useAuth();

    const [openLoader, setOpenLoader] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);

    const [rowCount, setRowCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [filter, setFilter] = useState("");
    const [extraFilter, setExtraFilter] = useState({});
    const [page, setPage] = useState(1);

    const [activities, setActivities] = useState([]);

    const getActivities = async (filter = "", extraFilter = {}, page = 1, pageSize = 10) => {
        setOpenLoader(true);
        const params = {
            ...extraFilter,
            search: filter,
            course: courseId,
            role_name: auth?.selectedRole?.name,
        };

        const res = await ApiService.getActivities(page, pageSize, params);

        setRowCount(res.data.count);
        setPageSize(pageSize);
        setFilter(filter);
        setExtraFilter(extraFilter);
        setPage(page);

        setActivities(
            res.data.results.map((activity) => ({
                id: activity.id,
                title: activity.title,
                owner: activity?.owner?.email,
                date: moment(activity?.datetime_added).format("DD/MM/YYYY"),
                visibility: VISIBILITY_MAP[activity.visibility],
                notifications: activity.notifications,
            }))
        );
        setOpenLoader(false);
    };

    const activitiesColumns = [
        {
            field: "title",
            headerName: "Título",
            width: 150,
            renderCell: (params) => {
                if (
                    ["admin", "superadmin"].includes(auth?.selectedRole?.name) ||
                    ["teacher", "student"].includes(auth?.selectedRole?.name)
                ) {
                    return (
                        <Badge
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "left",
                            }}
                            variant="dot"
                            color="secondary"
                            invisible={
                                ["superadmin"].includes(auth?.selectedRole?.name)
                                    ? true
                                    : params.row.notifications.filter((n) =>
                                          PENDING_NOTIFICATION_MAP[
                                              auth?.selectedRole?.name
                                          ].includes(n.category)
                                      ).length === 0
                            }
                        >
                            {params.row.title}
                        </Badge>
                    );
                } else {
                    return params.row.title;
                }
            },
        },
        { field: "visibility", headerName: "Visibilidad", width: 150 },
        { field: "date", headerName: "Fecha", width: 150 },
        { field: "owner", headerName: "Propietario", width: 200 },
        {
            field: "actions",
            headerName: "Acciones",
            width: 300,
            hideable: true,
            renderCell: (params) => {
                return (
                    <Button
                        variant="contained"
                        onClick={() => {
                            navigate(
                                `/${auth.selectedRole?.name}/${courseId}/activity/${params.row.id}`
                            );
                        }}
                    >
                        Ver actividad
                    </Button>
                );
            },
        },
    ];

    return (
        <div style={{ marginTop: "20px" }}>
            <FilterBar
                columnVisibilityModel={columnVisibilityModel}
                onPageChange={getActivities}
                openLoader={openLoader}
                rowCount={rowCount}
                columns={activitiesColumns}
                rows={activities}
                pageSize={pageSize}
            />

            <GenericDialog
                title={`Título actividad`}
                open={openDialog}
                setOpen={setOpenDialog}
                mandatoryText={false}
            >
                <DialogContent>
                    <p>Título enunciado</p>
                    <p>Enunciado</p>
                    <p>Objetivo</p>
                    <p>Descripción actividad</p>
                    <Button variant="contained" onClick={() => navigate("/grapher/4")}>
                        Resolver
                    </Button>
                </DialogContent>
            </GenericDialog>
        </div>
    );
};

export default CourseActivitiesList;
